export const removeTrailingSlash = (str: string) =>
	str.endsWith("/") ? str.substring(0, str.length - 1) : str;

export function validApplicationNumber(appNo: string) {
	return appNo && Number(appNo.replace("-", "")) > 0;
}
